import React, { useEffect, useState } from "react";
import logo from "../../../../../Assets/Image/Thebook24.svg";
import img from "../../../../../Assets/Image/paidStamp.png"
import img2 from "../../../../../Assets/Image/codStamp.png"
import { numberToWords } from "../../../../../Utilities/NumberToWord";

const OrderPrint = ({ isOpen, orders, onClose, allData }) => {
    const [isDisabled, setIsDisabled] = useState(true);

    const handlePrint = () => {
        const printWindow = window.open('', '_blank'); // Open a new window for printing
        const content = document.querySelector('.printingContainer').innerHTML;

        printWindow.document.write(`
            <html>
                <head>
                    <style>
                        body{
                        display:flex;
                        justify-content:center;
                        align-item:center;

                        }
                        .packing-slip {
                            font-family: Arial, sans-serif;
                            color: #333;
                            padding: 5px 10px;
                            background: white;
                            width: 98%;
                            margin: 0 auto;
                            page-break-after: always;
                             break-inside: avoid;
                        }
                        .packing-slip:last-child{
                        page-break-after: auto;
                        }
                        .printer-button h1 {
                            background-color: white;
                            padding: 5px 10px;
                            font-size: 1.3rem;
                            border-radius: 5px;
                        }
    
                        .printer-button {
                            padding-top: 15px;
                            position: sticky;
                            top: 0;
                            left: 0;
                            right: 45px;
                            bottom: 0;
                            display: flex;
                            justify-content: end;
                            z-index: 1002;
                            height: 100vh;
                        }
                        
                        .packing-slip-header {
                            display: flex;
                            justify-content: space-between;
                            border-bottom: 2px solid #000;
                        }
    
                        .packing-slip-title {
                            font-size: 24px;
                            font-weight: bold;
                        }
    
                        .packing-slip-order-details {
                            text-align: right;
                        }
                        .amount-words{
                          border-bottom: 2px solid #000;
                        }
                        
                        .packing-slip-address {
                            display: flex;
                            justify-content: space-between;
                            margin-top: 5px;
                        }
    
                        .packing-slip-ship-to,
                        .packing-slip-bill-to {
                            width: 45%;
                        }
    
                         h3 {
                            font-size: 18px;
                            margin-bottom: 5px;
                        }
    
                         .bill {
                            font-size: 18px;
                            margin-bottom: 5px;
                            display: flex;
                            justify-content: center;
                        }
    
                        table {
                            width: 100%;
                            border-collapse: collapse;
                        }
    
                        th,
                        td {
                            text-align: left;
                            padding: 8px;
                            border: 1px solid #ddd;
                        }
    
                        .packing-slip-item-details {
                            display: flex;
                            align-items: center;
                        }
    
                        .packing-slip-item-image {
                            width: 80px !important;
                            height: 85px;
                            margin-right: 10px;
                        }

                        .packing-slip-footer {
                            text-align: center;
                            font-size: 14px;
                        }
                        .page-break {
                            page-break-before: always; 
                        }
                        
                        .printingContainer {
                            visibility: visible;
                            width: 100%;
                            padding: 10px;
                            top: 0;
                            left: 0;
                        }
    
                        .printer-button {
                            display: none;
                        }
                            .td{
                            width:10%;
                            }
                        .packing-slip .summary{
                             margin-top: 20px;
                        }
                        .packing-slip .summary-row{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                             border-bottom:1px grey solid;
                             padding: 10px 0px;
                        }
                        .center-invoice-title {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            position: relative;
                        }
                        
                        .center-invoice-title::before,
                        .center-invoice-title::after {
                          content: "";
                          flex: 1;
                          height: 1px;
                          border-top: 1px dashed #333; /* Dashed line */
                          margin: 0 10px;
                        } 
                        .note-add{
                          text-align: center;
                        }  
                        .font-w{
                          font-weight:600;
                        } 
                        .add-ft{
                          font-weight:300,
                          font-size:"13px"
                        }     
                    </style>
                </head>
                <body>
                    <div class="printingContainer">
                        ${content} <!-- Inject the orders content here -->
                    </div>
                </body>
            </html>
        `);
        // printWindow.document.close();
        // printWindow.print(); 

        // printWindow.onload = () => {
        //     const images = printWindow.document.images;
        //     let loadedCount = 0;

        //     for (let img of images) {
        //         if (img.complete) {
        //             loadedCount++;
        //         } else {
        //             img.onload = () => {
        //                 loadedCount++;
        //                 if (loadedCount === images.length) {
        //                     printWindow.focus();
        //                     printWindow.print();
        //                     printWindow.close();
        //                 }
        //             };
        //         }
        //     }

        //     if (loadedCount === images.length) {
        //         printWindow.focus();
        //         printWindow.print();
        //         printWindow.close();
        //     }
        // };

        // printWindow.onload = () => {
        //     const images = printWindow.document.images;
        //     const totalImages = images.length;
        //     let loadedImages = 0;

        //     // if (totalImages === 0) {
        //     //     printWindow.focus();
        //     //     printWindow.print();
        //     //     printWindow.close();
        //     // }

        //     const checkAllImagesLoaded = () => {
        //         loadedImages++;
        //         if (loadedImages === totalImages) {
        //             printWindow.focus();
        //             printWindow.print();
        //             printWindow.close();
        //         }
        //     };

        //     for (let img of images) {
        //         if (img.complete) {
        //             checkAllImagesLoaded();
        //         } else {
        //             img.onload = checkAllImagesLoaded;
        //             img.onerror = checkAllImagesLoaded; // important for broken images
        //         }
        //     }
        // };
    };

    // console.log(allData, "alldata");
    // console.log(orders, "orders");
    const [itemList, setItemList] = useState([]);

    useEffect(() => {
        if (allData) {
            const filter = allData?.filter((itm) => orders?.some((itm2) => itm2?.uuid === itm?.uuid));
            console.log(filter, "filter");
            setItemList(filter);
        } else {
            setItemList(orders);
        }
    }, [orders]);

    useEffect(() => {
        if (isOpen) {
            setTimeout(() => {
                setIsDisabled(false);
            }, 5000);
        }
    }, [isOpen]);

    // if (!isOpen) return null

    return (
        <>
            <div className="main-printer" onClick={() => onClose()} style={{ display: !isOpen && "none" }}>
                <button
                    className="printer-button"
                    style={{
                        zIndex: 10000000,
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        right: "150px",
                        backgroundColor: isDisabled ? "" : "",

                    }}
                    disabled={isDisabled}
                    onClick={!isDisabled ? handlePrint : undefined}
                >
                    <h1>Print</h1>
                </button>
                <button className="printer-button" style={{ zIndex: 10000000, cursor: "pointer" }} onClick={() => onClose()}><h1 onClick={() => onClose()}>cancel</h1></button>
                <div className="modal-printer" style={{ overflow: "scroll" }} >
                    <div className="flex printingContainer" >
                        {
                            itemList?.map((itm) => {
                                return (
                                    <>
                                        <div className="packing-slip page-break" >
                                            {/* Header */}
                                            <header className="packing-slip-header">
                                                <h1 className="packing-slip-title" style={{ display: "flex", alignItems: "center" }}><img src={logo} alt="logo" style={{ width: "18%" }} loading="lazy" /> THE BOOKS 24</h1>
                                                <div className="packing-slip-order-details">
                                                    <p><strong>Order #</strong> {itm.orderId}</p>
                                                    <p><strong>Date:</strong> {new Date(itm?.orderAt).toLocaleDateString('en-US', {
                                                        year: 'numeric',
                                                        month: 'long',
                                                        day: 'numeric',
                                                    })}</p>
                                                </div>
                                            </header>
                                            {/* Address Section */}
                                            {itm?.paymentType === "COD" && <>
                                                <div className="amount-words">
                                                    <h3>{itm?.paymentType} Amount Rs.{itm?.orderTotal} / {numberToWords(itm?.orderTotal)}</h3>
                                                </div>
                                                <div className="amount-words">
                                                    <h3>E Biller ID - 59666</h3>
                                                </div>
                                            </>}
                                            {(itm?.standardDelivery === true && itm?.paymentType === "ONLINE") && <>
                                                <div className="amount-words">
                                                    <h3>{itm?.paymentType} Amount Rs.{itm?.orderTotal} / {numberToWords(itm?.orderTotal)}</h3>
                                                </div>
                                                <div className="amount-words">
                                                    <h3>Registered Parcel ID - 3000067970</h3>
                                                </div>
                                            </>}

                                            <section className="packing-slip-address" style={{ display: "flex", justifyContent: "space-between", alignItems: "start", width: "100%" }}>
                                                <div className="packing-slip-ship-to">
                                                    <h3>SHIP TO</h3>
                                                    <p>Name: {itm?.customerAddressDetail?.firstName} {itm?.customerAddressDetail?.lastName}</p>
                                                    {/* <p>{itm?.customerAddressDetail?.addressLine1}{itm?.customerAddressDetail?.addressLine1}</p> */}

                                                    <p>Address: {itm?.customerAddressDetail?.addressLine1}, {itm?.customerAddressDetail?.landMark}</p>
                                                    <p>City: {itm?.customerAddressDetail?.cityTitle}</p>
                                                    <p>PinCode: {itm?.customerAddressDetail?.pinCode}</p>
                                                    <p>State: {itm?.customerAddressDetail?.stateTitle}</p>
                                                    <p>Mobile Number: {itm?.customerAddressDetail?.mobileNumber}</p>
                                                </div>
                                                <div className="packing-slip-bill-to">
                                                    <h3>FROM TO</h3>
                                                    <p style={{ fontWeight: 300, fontSize: "13px" }} className="add-ft">Sawariya Seth Retail LLP,<br /> Address: H-42, Central Colony, Jaipur, Jaipur, Rajasthan, 302012,<br /> 9782938018</p>
                                                    <p className="font-w">(If undelivered return please at ) <br /> Shri Shyam Book Depot, Main Kanta Circle, kharini phatak road, jhotwara, jaipur-302012</p>
                                                    <p className="font-w">Mobile Number: 9782938018</p>
                                                </div>
                                            </section>

                                            <div className="center-invoice-title">
                                                <h2>Invoice</h2>
                                            </div>

                                            {/* Items Table */}
                                            <section className="packing-slip-items">
                                                <h3>{itm?.standardDelivery ? "Standard Delivery" : "Express Delivery"} / Payment Type:- {itm?.paymentType}</h3>
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>Item</th>
                                                            <th>Price</th>
                                                            <th>Quantity</th>
                                                            <th>Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {itm.itemDetailList?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div className="packing-slip-item-details">
                                                                        <img src={item.itemImageUrls?.[0]} alt={item.name} className="packing-slip-item-image" loading="lazy" />
                                                                        <p>{item.title}</p>
                                                                        {/* <p><strong>SKU:</strong> {item.sku}</p> */}
                                                                    </div>
                                                                </td>
                                                                <td className="td">{item.sellingPrice}</td>
                                                                <td className="td">{item.quantity}</td>
                                                                <td className="td">{item.quantity * item.sellingPrice}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </section>
                                            <div className="summary">
                                                <div className="summary-row">
                                                    <span>Sub Total</span>
                                                    <span>{itm?.subTotal}</span>
                                                </div>
                                                <div className="summary-row">
                                                    <span>Coupon Discount</span>
                                                    <span className="negative">{itm?.couponDiscountAmount}</span>
                                                </div>
                                                <div className="summary-row">
                                                    <span>Delivery Charges</span>
                                                    <span className="negative">{itm?.deliveryCharges + itm?.packingCharges - itm?.codCharges}</span>
                                                </div>
                                                {itm?.paymentType === "COD" && <div className="summary-row">
                                                    <span>COD Charges</span>
                                                    <span className="negative">{itm?.codCharges}</span>
                                                </div>}
                                                <div className="summary-row total">
                                                    <span>Order Total</span>
                                                    <span className="negative">{itm?.orderTotal}</span>
                                                </div>
                                                <div className="paid-stamp" style={{ position: 'relative', textAlign: 'center' }}>
                                                    {itm?.paymentType === 'ONLINE' ? (

                                                        <img
                                                            src={img}
                                                            alt="Paid Stamp"
                                                            style={{
                                                                position: 'absolute',
                                                                top: '-60px',
                                                                left: '50%',
                                                                transform: 'translate(-50%, -50%)',
                                                                width: '150px',
                                                                opacity: '0.8',
                                                            }}
                                                        />

                                                    ) :
                                                        (
                                                            <img
                                                                src={img2}
                                                                alt="COD Stamp"
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '-60px',
                                                                    left: '50%',
                                                                    transform: 'translate(-50%, -50%)',
                                                                    width: '215px',
                                                                    opacity: '0.8',
                                                                }}
                                                            />
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            {/* Footer */}
                                            {/* <div className="">
                                                <p className="note-add" style={{ textAlign: "center" }}><strong>Note:-</strong> In case of return use this address Shri Shyam Book Depot, Main Kanta Circle, kharini phatak road, jhotwara, jaipur-302012</p>
                                            </div> */}
                                            <footer className="packing-slip-footer">
                                                <p>Thank you for shopping with us!</p>
                                                <p><strong>The Books24</strong></p>
                                                <p>Shri Shyam Book Depot, Jhotwara, Jaipur, Rajasthan</p>
                                                <p>thebooks24india@gmail.com</p>
                                            </footer>
                                        </div>
                                    </>
                                )
                            })
                        }

                    </div>
                </div>

            </div>
        </>
    );
};

export default OrderPrint;